@import '../../../theme.scss';

verdocs-toolbar-icon {
  font-family: $verdocs-primary-font;
  //display: inline-block;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;

  .icon {
    display: inline-block;
    cursor: pointer;

    svg {
      fill: $choice-available-color;
    }
  }

  .tooltip {
    display: none;
    box-shadow: 0 0 10px 1px #999999;
    background: #ffffff;
    color: $label-color;
    max-width: 240px;
    font-weight: bold;
    padding: 5px 10px;
    font-size: 13px;
    position: relative;
    border-radius: 4px;
    z-index: 20000;
    white-space: nowrap;

    .arrow,
    .arrow::before {
      position: absolute;
      width: 8px;
      height: 8px;
      background: inherit;
    }

    .arrow {
      visibility: hidden;
      top: -4px;
    }

    .arrow::before {
      visibility: visible;
      content: '';
      transform: rotate(45deg);
    }

    &[data-show] {
      display: block;
    }

    &[data-popper-placement^='top'] > .arrow {
      bottom: -4px;
    }

    &[data-popper-placement^='bottom'] > .arrow {
      top: -4px;
    }

    &[data-popper-placement^='left'] > .arrow {
      right: -4px;
    }

    &[data-popper-placement^='right'] > .arrow {
      left: -4px;
    }

    // For the floating menu
    &[data-popper-placement^='left'] {
      //margin-right: 22px !important;
      padding: 3px 10px;

      & > .arrow {
        right: -1px;
      }
    }
  }
}
